export default __webpack_public_path__ + "static/media/icon-online.b0622b15.svg";